export default __webpack_public_path__ + "static/media/ic-abstract-03.0abae600.svg";